import { createFileRoute } from '@tanstack/react-router';

import { PublicLegalPage } from '~/features/auth/public-legal-page';

export const Route = createFileRoute('/_public/privacy')({
  component: () => <PublicLegalPage kind="privacy" />,
});
